export const  EMPLOYEE_SESSION = "Employee Sessions"
export const  ADD_EMPLOYEE_SESSION = "Add Employee Session"
export const  EDIT_EMPLOYEE_SESSION = "Edit Employee Session"

export const  EMPLOYEE_SESSION_PAGES = {
    TABLE: "table",
    FORM: "form",
    REPORT: "report"
}
// tooltip names
export const BACK = "Back to Menu"
export const ROWS_PER_PAGE = 50
export const DEFAULT_SORT_BY_HEAD_CELL = "date"
export const ROWS_PER_PAGE_LABEL = "Results"


export const EMPLOYEE_SESSION_FIELDS = [
    {id: 'name', label: 'Employee Name', align: "center"},
    {id: 'clockIn', label: 'Clock In', align: "center"},
    {id: 'clockOut', label: 'Clock Out', align: "center"},
    {id: 'totalHours', label: 'Total Working Hours', align: "center"},
    {id: 'totalPay', label: 'Total Pay', align: "center"},
    {id: 'state', label: 'State', align: "center"},
]

export const STATE_OPTIONS = [
    {name: "Paid"},
    {name: "Unpaid"},
]